import { appRedirect, getBilling } from "app/NativeActions";
import { Container, Copy, KeyboardView } from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";
import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import BillingAddons from "../BillingDashboard/BillingAddons";
import PlanModules from "../BillingDashboard/PlanModules";

const EnginesAndAddons = props => {
  const { user, token } = useSelector(({ auth }) => auth);

  const dispatch = useDispatch();

  const goBack = useCallback(() => {
    dispatch(
      appRedirect({ redirect: "goBack", payload: { type: "settings" } })
    );
  }, [dispatch]);

  useEffect(() => {
    if (user && user.team_clearance_level < 2 && user.team_owner != 1) {
      goBack();
    }
    dispatch(getBilling({ token: token, type: "lead_limits" }));
    dispatch(getBilling({ token: token, type: "conversation_limits" }));
    dispatch(getBilling({ token: token, type: "list_lead_limits" }));
  }, [user]);

  return (
    <Container>
      <Header
        title={"Engines & Add-ons"}
        leftButtonIcon={"arrow-back"}
        leftButtonAction={goBack}
      />
      <KeyboardView>
        <PlanModules {...props} />
        <BillingAddons />
      </KeyboardView>
    </Container>
  );
};

export default EnginesAndAddons;
